// Thirdparty
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "./../assets/logo.svg";
// Components
import LoginModal from "./LoginModal.js";
// Styles
import "./../styles/NavBar.css";
import "./../styles/Dropdown.css";

// Services
const Routes = require("./../services/routes.js");

function NavBar() {
  const [isOpen, setIsOpen] = useState([false,false]);

  useEffect(() => {}, []);

  return (
    <header>
      {/*
      <div className="promo-bar">
        <div className="container">

          <p>Add this for a promotional banner</p>

        </div>
      </div>
      */}
      
      <div className="nav-container">
        <div className=" header-app">
          <Link to="/">
            <img src={logo} alt="the logo" className="logo" />
          </Link>
          <nav className="nav-bar">
            <ul className="show-desktop hide-mobile">
              <li>
                <Link to="/" className="link-book-now nav-bar-link">
                  Open App
                </Link>
              </li>

              <li>
                <div className="dropdown">
                  <img
                    src={require("./../assets/icon-user.svg").default}
                    alt="login"
                    className="loginmodal dropbtn"
                  />

                  {
                  localStorage.verified!==undefined?
                  // LOGGED IN 
                    <div className="dropdown-content">
                      <Link to="/Deposit" className="dropdown-link">
                        Deposit
                      </Link>
                      <Link to="/Account" className="dropdown-link">
                        Account
                      </Link>
                      <Link to="/Withdrawal" className="dropdown-link">
                        Withdrawal
                      </Link>
                      <a className="dropdown-link" onClick={()=>setIsOpen([true,false])}>
                        Log Out
                      </a>
                    </div>
                  :
                  // LOGGED OUT
                    <div className="dropdown-content">
                      <a className="dropdown-link" onClick={()=>setIsOpen([true,false])}>
                        Log In
                      </a>
                      <a className="dropdown-link" onClick={()=>setIsOpen([true,true])}>
                        Sign Up
                      </a>
                    </div>
                  }
                </div>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      
      <LoginModal open={isOpen} onClose={()=>setIsOpen([false,false])}/>
    </header>
  );
}

export default NavBar;
